import { Swiper, Navigation, Pagination, Autoplay } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let enterpriseBanner = new Swiper(".enterprise-banner__slider", {
        watchOverflow: true,
        autoplay: {
            delay: 6000,
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let enterpriseGallery = new Swiper(".enterprise-gallery__slider", {
        watchOverflow: true,
        slidesPerView: 2,
        spaceBetween: 30,
        navigation: {
            nextEl: ".gallery-button-next",
            prevEl: ".gallery-button-prev",
        },
        breakpoints: {
            600: {
                slidesPerView: 1,
            },
        },
    });

    let mainBanner = new Swiper(".main__banner", {
        watchOverflow: true,
        navigation: {
            nextEl: '.main-button-next',
            prevEl: '.main-button-prev',
        },
        pagination: {
            el: ".main-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let lotsGallery = new Swiper(".lots__gallery", {
        watchOverflow: true,
        navigation: {
            nextEl: '.lots-button-next',
            prevEl: '.lots-button-prev',
        },
    });

    let videoGallery = new Swiper(".video__gallery", {
        watchOverflow: true,
        navigation: {
            nextEl: '.video-button-next',
            prevEl: '.video-button-prev',
        },
    });
};
